import script from "./PenjadwalanPresentasi.vue?vue&type=script&setup=true&lang=js"
export * from "./PenjadwalanPresentasi.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__